<template>
    <el-dialog
        v-dialogDrag
        append-to-body
        :visible.sync="printForm.dialogVisible"
        v-if="printForm.dialogVisible"
        width="95%"
        :before-close="handleClose"
        :close-on-click-modal="false"
        class="print-custom-dialog"
    >
        <div slot="title" class="dialog-title">
            <i class="dialog-title-left-icon" :class="icon" v-if="icon"></i>
            <div class="dialog-title-word">{{ title }}</div>
        </div>
        <div class="dialog-body">
            <slot></slot>
        </div>
        <div class="dialog-footer" slot="footer">
            <!-- <el-button type="primary" size="small">保存</el-button> -->
            <el-button @click="handleClose" size="small">关闭</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: "printSysCustom",
    data() {
        return {
            tableData: [],     //模板列表数据
            multipleSelection: {},  //选择的模板数据
            total: 10,      //tableData的总数
            queryParams: {      //查询条件
                size: 10,       //列表查询每次10条
                value: "",      //查询条件
            },
        };
    },
    props: {
        // 弹出框title
        title:{
            type:String,
            default:"",
            required: true
        },
        // 字体图标
        icon:{
            type:String,
            default:""
        },
        // 弹窗基本数据
        printForm: {  
            type: Object,
            default: () => {},
        },
    },
    created() {
        
    },
    mounted() {},
    methods: {
        //弹框关闭
        handleClose() {
            this.printForm.dialogVisible = false;
            this.$emit("handleClose")
        },
    },
};
</script>
<style lang="less" scoped>
    @mainColor: #ef7c1b;
    .print-custom-dialog{
        user-select: none;
        *{
            box-sizing: border-box !important;
        }
        ::v-deep {
            *{
                box-sizing: border-box !important;
            }
            .prop-tabs .hiprint-option-items.active{
                height: auto;
            }
            .el-dialog{
                border-radius: 6px;
                height: 95%;
                margin: 0 !important;
                display: flex;
                flex-direction: column;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            .el-dialog__header {
                border-radius: 6px 6px 0 0;
                color: #666;
                border-bottom: 1px solid #e9e9e9;
                padding: 12px 20px 12px;
                background-color: #f9f9f9;
            }
            .el-dialog__footer{
                border-top: 1px solid #f0ecec;
                padding: 10px 20px;
                justify-content: flex-end !important;
            }
            .el-dialog__headerbtn{
                top: 15px;
                font-size: 18px;
            }
            .el-dialog__body{
                padding: 0;
                height: calc(100% - 101px);
                overflow: hidden;
                max-height: none !important;
            }
            .el-table__cell.gutter{
                background: #f6f6f6;
            }
        }
        .dialog-title{
            display: flex;
            align-items: center;
            height: 24px;
            width: 60%;
        }
        
        .dialog-title-left-icon{
            font-size: 20px;
            color: @mainColor;
        }

        .dialog-title-word{
            margin-left: 8px;
            font-size: 14px;
        }
        .dialog-body{
            height: 100%;
        }
    }
</style>